// Copyright 2026. WebPros International GmbH. All rights reserved.

import moxios from 'moxios';

export const getResponse = <I>(data: I) => ({ data });

export const defaultMeta = {
    total: 0,
    to: 0,
    last_page: 1,
    from: 0,
    per_page: 50,
    current_page: 1,
};

export const getPaginatedResponse = <I>(data: I, links = {
    first: '',
    last: '',
    next: '',
    prev: '',
}, meta = defaultMeta) => ({
        data,
        links,
        meta,
    });

export const getGraphResponse = <I>(items: I) => ({
    items,
    name: '',
    uuid: '',
    interval: {
        value: 20,
        measurement: '',
    },
});

export const mockResponse = <I>(data: I) => ({
    data,
    statusText: '',
    status: 200,
    headers: {},
    config: {},
});

export interface IResponseStruct {
    httpCode: number;
    responseBody: Record<string, unknown>;
}

export const moxiosResponse = (item: IResponseStruct[]) => {
    moxios.wait(() => {
        item.forEach((req, index) => {
            const request = moxios.requests.at(index);
            request.respondWith({
                status: req.httpCode,
                response: getResponse(req.responseBody),
            });
        });
    });
};
